import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import DeliveryDateComponent from '../components/delivery-date.component';
import { deliveryDates } from '../../../../../../redux/delivery-dates/action';
import { selectDeliveryDatesQueryItems } from '../../../../../../redux/delivery-dates/selector';

const ManagementDeliveryDate = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const DeliveryDateQuery = useSelector(selectDeliveryDatesQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const [
    selectedDeliveryDates,
    setSelectedDeliveryDates
  ] = useState<any>([])

  const fetchDeliveryDatesQueryById = () => {
    dispatch(deliveryDates.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/delivery-dates/query`, entity: 'deliveryDates', jsonData: {

        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    })




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedDeliveryDates({ ...selectedDeliveryDates, [field]: event })
  }

  useEffect(
    () => {
      if (parmas?.id > 0) {
        fetchDeliveryDatesQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }


    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedDeliveryDates(DeliveryDateQuery?.result?.items)
      }
    },
    [isQuery]
  )
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(deliveryDates.resetAction({ actionType: 'update' }))
      await dispatch(deliveryDates.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/delivery-dates`, entity: 'deliveryDates', jsonData: {

          Records: [
            selectedDeliveryDates
          ]

        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(deliveryDates.resetAction({ actionType: 'create' }))
      dispatch(deliveryDates.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/delivery-dates`, entity: 'deliveryDates', jsonData: {

          Records: [
            selectedDeliveryDates
          ]

        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/configuration/shipment/delivery-dates')
  }

  return (
    <>

      {isLoading ? <PageLoader /> :
        <DeliveryDateComponent
          handleInnerFormChange={handleInnerbasicFormChange}
          selectedDeliveryDates={selectedDeliveryDates}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )

}

export default ManagementDeliveryDate;